module.exports = __webpack_public_path__ + "static/media/slider-1.4ac09358.jpg";